/* unplugin-vue-components disabled */import { render } from "./Viphome.vue?vue&type=template&id=50182ce2&scoped=true&ts=true"
import script from "./Viphome.vue?vue&type=script&lang=ts"
export * from "./Viphome.vue?vue&type=script&lang=ts"

import "./Viphome.vue?vue&type=style&index=0&id=50182ce2&lang=scss&scoped=true"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50182ce2"]])

export default __exports__